function dkCustomInit() {
  var checkJquery = function(){
    if (typeof jQuery === "undefined"){
        return false;
    } else {
        clearTimeout(jqInterval);
        jQueryIsReady();
    }
  }
  var jqInterval = setInterval(checkJquery,1000);
}

/* this is like $(document).ready() */
var jQueryIsReady = function() {

  initTabs();
  initTeamsModal();
  
  /* MOVED TO product-options.js
  if ($('.product-options--option.option-color').length) {
    initPDPOtherColors();
  }*/

  /* Hide/Show Persistent banner on scroll */ 
  /*if ($('.persistent-banner').length) {
    $(window).scroll(function() {
      if ($(this).scrollTop() > 0) {
        $('.persistent-banner').fadeOut();
      } else {
        $('.persistent-banner').fadeIn();
      }
    });
  }*/

} // end jQueryIsReady

function initTabs() {
  var tabsRoot = $('.tabs--root');
  if (tabsRoot.length) {
    tabsRoot.each((i,el)=>{
      var tabs = $(el).find('.tabs--menu-item');
      tabs.on( "click", function(e) {
        e.preventDefault();  
        var tab = $(this);
        tab.addClass('active-tab').siblings().removeClass('active-tab'); 
        var pnlId = tab.find('a').attr('href');
        var pnl = $(el).find(pnlId);
        pnl.addClass('active-panel').siblings().removeClass('active-panel');
        return false;
      });
    });
  }
}

function initTeamsModal() {
  var leaguesList = $('.leagues-with-icon--list');
  var teamsModal = $('.modal--root[data-id="teams"] .leagues-teams--container');
  if (leaguesList.length && teamsModal.length) {
      leaguesList.on('click', '.leagues-with-icon--link', function (e) {
        var modalTrigger = $(this);
        var handle = modalTrigger.data('handle');
        var activeTab = teamsModal.find('.tabs--menu-item[data-handle="'+handle+'"]');
        activeTab.trigger('click');
    });
  }
}

if (/complete|interactive|loaded/.test(document.readyState)) {
    dkCustomInit();
} else {
    document.addEventListener('DOMContentLoaded', dkCustomInit);
};


/* Hide/Show Persistent banner on scroll - MOVED TO jQueryIsReady */
/* */
